module.exports = __webpack_public_path__ + "img/Verification.db6a3520.svg";